import React from "react";
import SCANBUTTON from "../../assets/scanicon.svg";
import { useNavigate } from "react-router-dom";
import { ReactSession } from "react-client-session";

const ScanButtton = ({ row }) => {
  const navigate = useNavigate();

  const scanHandel = () => {
    if (row.mark_box || ReactSession.get("role") === "2") {
      ReactSession.set("box_id_s", row.stockists_master_id);
      navigate("/manual-entry-view");
    } else {
      ReactSession.set("box_id", row.stockists_master_id);
      ReactSession.set("order_type", row.order_type);
      navigate("/scan");
    }
  };

  return (
    <button onClick={scanHandel} className="table-options-btn">
      <img src={SCANBUTTON} alt="" />
    </button>
  );
};

export default ScanButtton;
